import { Route } from 'react-router-dom';
import { UserSettingsPage } from './pages/UserSettingsPage.js';

/**
 * User — per-user settings. Phase B adds preferences + feedback /
 * avatar upload backed by `/v1/user/*` writes.
 */
export function userRoutes(): JSX.Element {
  return <Route path="/user" element={<UserSettingsPage />} />;
}
